import React from "react";
import { Select as MuiSelect } from "@mui/material";

const SafeSelect = React.forwardRef(function SafeSelect(props, ref) {
  const { children, ...restProps } = props;
  const validChildren = React.Children.toArray(children).filter((child) =>
    React.isValidElement(child)
  );

  return (
    <MuiSelect ref={ref} {...restProps}>
      {validChildren}
    </MuiSelect>
  );
});

export default SafeSelect;